import React, { useEffect } from "react";
import { Grid, TextField, MenuItem, Switch, FormControlLabel } from "@mui/material";
import { SwitchRelais } from "../../models/testSteps/switchRelais.ts";
import { Relais } from "../../models/signalUsers/relais.ts";
import { getCombinedSignalLabel } from "../../utils/signalUtils.ts";

interface Props {
  data: SwitchRelais;
  onChange: (updated: SwitchRelais) => void;
  setIsValid: (valid: boolean) => void;
  relaisOptions: Relais[];
}

const EditSwitchRelaisForm: React.FC<Props> = ({ data, onChange, setIsValid, relaisOptions }) => {
  useEffect(() => {
    setIsValid(data.name.trim() !== "" && data.relais_id !== "" && data.relais_id !== undefined);
  }, [data, setIsValid]);

  const handleRelaisChange = (id: string) => {
    const rel = relaisOptions.find(r => r.id === id);
    if (!rel) return;
    const switchName = getCombinedSignalLabel(rel.high_signal, rel.low_signal);
    onChange({ ...data, relais_id: id, switch_name: switchName });
  }

  return (
    <Grid container spacing={2} mt={1}>
      <Grid size={12}>
        <TextField
          label="Name"
          fullWidth
          value={data.name}
          onChange={(e) => onChange({ ...data, name: e.target.value })}
        />
      </Grid>
      <Grid size={12}>
        <TextField
          select
          fullWidth
          label="Relais auswählen"
          value={data.relais_id}
          onChange={(e) => handleRelaisChange(e.target.value)}
        >
          {relaisOptions.map((rel) => (
            <MenuItem key={rel.id} value={rel.id}>
              {getCombinedSignalLabel(rel.high_signal, rel.low_signal)}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={12}>
        <FormControlLabel
          control={
            <Switch
              checked={data.status}
              onChange={(e) => onChange({ ...data, status: e.target.checked })}
              color="primary"
            />
          }
          label={data.status ? "geschlossen" : "offen"}
        />
      </Grid>
    </Grid>
  );
};

export default EditSwitchRelaisForm;
